import { render, staticRenderFns } from "./DriversPage.vue?vue&type=template&id=5206e9a0&"
import script from "./DriversPage.vue?vue&type=script&lang=js&"
export * from "./DriversPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports